import { atomFamily, selectorFamily } from "recoil";
import {
  defaultToolbarFilterState,
  type TicketToolbarFilterState,
} from "@sd/lib/ticketListFilterStorage";

/** Per-scope ticket toolbar filters (agent:all, agent:my-tickets, admin:tickets, …). */
export const ticketToolbarFiltersAtomFamily = atomFamily<
  TicketToolbarFilterState,
  string
>({
  key: "ticketToolbarFilters",
  // Fresh object per scope — avoid shared mutable default across queues.
  default: () => defaultToolbarFilterState(),
});

export const ticketToolbarFiltersSelectorFamily = selectorFamily<
  TicketToolbarFilterState,
  string
>({
  key: "ticketToolbarFiltersSelector",
  get:
    scope =>
    ({ get }) =>
      get(ticketToolbarFiltersAtomFamily(scope)),
});
